module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Communication and Contract Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Account Communication Preferences")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.toBeContactedAsVolunteer),
      expression: "AccountEdit.toBeContactedAsVolunteer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.AccountEdit.toBeContactedAsVolunteer) ? _vm._i(_vm.AccountEdit.toBeContactedAsVolunteer, null) > -1 : (_vm.AccountEdit.toBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.AccountEdit.toBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.AccountEdit, "toBeContactedAsVolunteer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.AccountEdit, "toBeContactedAsVolunteer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.AccountEdit, "toBeContactedAsVolunteer", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like to be contacted if there are volunteer opportunities in my area.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.toReceiveNewsLetter),
      expression: "AccountEdit.toReceiveNewsLetter"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.AccountEdit.toReceiveNewsLetter) ? _vm._i(_vm.AccountEdit.toReceiveNewsLetter, null) > -1 : (_vm.AccountEdit.toReceiveNewsLetter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.AccountEdit.toReceiveNewsLetter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.AccountEdit, "toReceiveNewsLetter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.AccountEdit, "toReceiveNewsLetter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.AccountEdit, "toReceiveNewsLetter", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like email updates from OneSight EssilorLuxottica Foundation.")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Program Contract")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_c('a', {
    staticClass: "g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.GeneratePdf()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" "), (_vm.isContractLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../../../../../static/img/loading.gif")
    }
  })]) : _vm._e(), _vm._v("\n          to download a copy of your contract.")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-309c141a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-309c141a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/userAccount/accountEdit/EditCommunicationInfo.vue
// module id = 487
// module chunks = 3